<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="organizations"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  to="/manage/edit/organization/add"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.logo="{ item }">
          <v-icon class="ml-2" v-if="item.logo !== null" color="green">
            mdi-image
          </v-icon>
          <v-icon v-else class="ml-2" color="grey">
            mdi-image-off-outline
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="primary" @click="$router.push('/manage/edit/organization/edit/' + item.id)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dialog: false,
      search: "",
      organizations: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: "Web",
          value: "web",
        },
        {
          text: this.$t("form.organization.logo"),
          value: "logo"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          width: "15%",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/organization";
      axios
        .get(path)
        .then(response => {
          this.organizations = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    deleteItem(item) {
      if (confirm(this.$t('message.confirm.delete'))) {
        let path = this.$store.state.endpoint + "/organization/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.organizations.indexOf(item);
            this.organizations.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t('message.correct.deleteItem')
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },
  }
};
</script>
